import React from "react";

const VolleyballMatchDetails = ({ matches, userNames, styles }) => {
  return matches.map((match, matchIndex) => (
    <div key={matchIndex} style={{ marginBottom: "clamp(18px, 4vw, 25px)" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "clamp(15px, 4vw, 20px)",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <h4
          style={{
            color: "#2c3e50",
            margin: 0,
            fontSize: "clamp(16px, 3.5vw, 20px)",
          }}
        >
          Match #{matchIndex + 1}
        </h4>
        <span
          style={{
            backgroundColor:
              match.winner === "user"
                ? "#27ae60"
                : match.winner === "opponent"
                ? "#e74c3c"
                : "#95a5a6",
            color: "white",
            padding: "clamp(3px, 1vw, 4px) clamp(10px, 2.5vw, 12px)",
            borderRadius: "20px",
            fontSize: "clamp(11px, 2.2vw, 12px)",
            fontWeight: "600",
          }}
        >
          {match.winner === "user"
            ? "WIN"
            : match.winner === "opponent"
            ? "LOSS"
            : "IN PROGRESS"}
        </span>
      </div>

      {/* Team Names & Set Score */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#f8f9fa",
          padding: "clamp(15px, 4vw, 20px)",
          borderRadius: "12px",
          marginBottom: "clamp(15px, 4vw, 20px)",
          border: "2px solid #e9ecef",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <div style={{ textAlign: "center", flex: 1, minWidth: "120px" }}>
          <h3
            style={{
              color: "#2c3e50",
              margin: "0 0 clamp(8px, 2vw, 10px) 0",
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            {match.userTeamName || "Your Team"}
          </h3>
          <div
            style={{
              fontSize: "clamp(28px, 7vw, 36px)",
              fontWeight: "bold",
              color: "#27ae60",
            }}
          >
            {match.userSets}
          </div>
          <div
            style={{ fontSize: "clamp(11px, 2.2vw, 12px)", color: "#6c757d" }}
          >
            Sets Won
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "clamp(18px, 4.5vw, 24px)",
            fontWeight: "bold",
            color: "#6c757d",
            minWidth: "60px",
            justifyContent: "center",
          }}
        >
          VS
        </div>
        <div style={{ textAlign: "center", flex: 1, minWidth: "120px" }}>
          <h3
            style={{
              color: "#2c3e50",
              margin: "0 0 clamp(8px, 2vw, 10px) 0",
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            {match.opponentTeamName || "Opponent Team"}
          </h3>
          <div
            style={{
              fontSize: "clamp(28px, 7vw, 36px)",
              fontWeight: "bold",
              color: "#e74c3c",
            }}
          >
            {match.opponentSets}
          </div>
          <div
            style={{ fontSize: "clamp(11px, 2.2vw, 12px)", color: "#6c757d" }}
          >
            Sets Won
          </div>
        </div>
      </div>

      {/* Match Info */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          gap: "clamp(12px, 3vw, 15px)",
          marginBottom: "clamp(15px, 4vw, 20px)",
          fontSize: "clamp(13px, 2.5vw, 15px)",
        }}
      >
        <p>
          <strong>Match Type:</strong>{" "}
          {match.matchType === "best_of_3" ? "Best of 3" : "Best of 5"}
        </p>
        <p>
          <strong>Sets Played:</strong> {match.sets?.length || 0}
        </p>
        <p>
          <strong>Total Players:</strong>{" "}
          {(match.userTeam?.length || 0) + (match.opponentTeam?.length || 0)}
        </p>
      </div>

      {/* Set Scores */}
      {match.sets && match.sets.length > 0 && (
        <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            🏐 Set by Set Scores
          </h4>
          <table style={styles.setsTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Set</th>
                <th style={styles.tableTh}>
                  {match.userTeamName || "Your Team"}
                </th>
                <th style={styles.tableTh}>
                  {match.opponentTeamName || "Opponent"}
                </th>
                <th style={styles.tableTh}>Target</th>
              </tr>
            </thead>
            <tbody>
              {match.sets.map((set, index) => {
                const isDecidingSet =
                  (match.matchType === "best_of_3" && index === 2) ||
                  (match.matchType === "best_of_5" && index === 4);
                const targetPoints = isDecidingSet ? 15 : 25;
                const setWinner =
                  set.userPoints > set.opponentPoints
                    ? "user"
                    : set.opponentPoints > set.userPoints
                    ? "opponent"
                    : "tie";

                return (
                  <tr
                    key={index}
                    style={{
                      backgroundColor:
                        setWinner === "user"
                          ? "#d4edda"
                          : setWinner === "opponent"
                          ? "#f8d7da"
                          : "transparent",
                    }}
                  >
                    <td style={styles.tableTd}>
                      Set {index + 1}{" "}
                      {isDecidingSet && (
                        <span style={{ color: "#dc3545", fontSize: "10px" }}>
                          (Deciding)
                        </span>
                      )}
                    </td>
                    <td style={styles.tableTd}>
                      <strong>{set.userPoints}</strong>
                      {setWinner === "user" && " 🏆"}
                    </td>
                    <td style={styles.tableTd}>
                      <strong>{set.opponentPoints}</strong>
                      {setWinner === "opponent" && " 🏆"}
                    </td>
                    <td style={styles.tableTd}>{targetPoints}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Point Events */}
      {match.pointEvents && match.pointEvents.length > 0 && (
        <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            📊 Point Events
          </h4>
          <table style={styles.setsTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Set</th>
                <th style={styles.tableTh}>Team</th>
                <th style={styles.tableTh}>Player</th>
                <th style={styles.tableTh}>Point Type</th>
              </tr>
            </thead>
            <tbody>
              {match.pointEvents.map((event, index) => (
                <tr key={index}>
                  <td style={styles.tableTd}>Set {event.set}</td>
                  <td style={styles.tableTd}>
                    {event.team === "user"
                      ? match.userTeamName
                      : match.opponentTeamName}
                  </td>
                  <td style={styles.tableTd}>{event.player}</td>
                  <td style={styles.tableTd}>
                    <span
                      style={{
                        backgroundColor:
                          event.pointType === "attack"
                            ? "#28a745"
                            : event.pointType === "block"
                            ? "#dc3545"
                            : event.pointType === "serve"
                            ? "#ffc107"
                            : event.pointType === "opponent_error"
                            ? "#6c757d"
                            : "#17a2b8",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {event.pointType.replace("_", " ").toUpperCase()}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Substitutions */}
      {match.substitutions && match.substitutions.length > 0 && (
        <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            🔄 Substitutions
          </h4>
          <table style={styles.setsTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Set</th>
                <th style={styles.tableTh}>Team</th>
                <th style={styles.tableTh}>Player Out</th>
                <th style={styles.tableTh}>Player In</th>
                <th style={styles.tableTh}>Reason</th>
              </tr>
            </thead>
            <tbody>
              {match.substitutions.map((sub, index) => (
                <tr key={index}>
                  <td style={styles.tableTd}>Set {sub.set}</td>
                  <td style={styles.tableTd}>
                    {sub.team === "user"
                      ? match.userTeamName
                      : match.opponentTeamName}
                  </td>
                  <td style={styles.tableTd}>{sub.playerOut}</td>
                  <td style={styles.tableTd}>{sub.playerIn}</td>
                  <td style={styles.tableTd}>
                    <span
                      style={{
                        backgroundColor:
                          sub.reason === "injury"
                            ? "#dc3545"
                            : sub.reason === "tactical"
                            ? "#28a745"
                            : "#6c757d",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {sub.reason}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Team Rosters with Positions */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "clamp(12px, 4vw, 20px)",
        }}
      >
        <div>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(8px, 2vw, 10px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            👥 {match.userTeamName || "Your Team"}
          </h4>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "clamp(12px, 3vw, 15px)",
              borderRadius: "8px",
            }}
          >
            {match.userTeam && match.userTeam.length > 0 ? (
              match.userTeam.map((player, index) => {
                const playerName = player.userId
                  ? userNames[player.userId] || player.name
                  : player.name;
                return (
                  <div
                    key={index}
                    style={{
                      padding: "8px 0",
                      borderBottom: "1px solid #dee2e6",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      <strong>#{player.number}</strong> {playerName}
                      {player.isLibero && (
                        <span
                          style={{
                            color: "#28a745",
                            fontSize: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          (Libero)
                        </span>
                      )}
                      {player.isCustom && (
                        <span
                          style={{
                            color: "#6c757d",
                            fontSize: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          (Custom)
                        </span>
                      )}
                    </span>
                    <span style={{ fontSize: "12px", color: "#6c757d" }}>
                      {player.position}
                    </span>
                  </div>
                );
              })
            ) : (
              <div style={{ color: "#6c757d", fontStyle: "italic" }}>
                No players added
              </div>
            )}
          </div>
        </div>
        <div>
          <h4 style={{ color: "#2c3e50", marginBottom: "10px" }}>
            👥 {match.opponentTeamName || "Opponent Team"}
          </h4>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "15px",
              borderRadius: "8px",
            }}
          >
            {match.opponentTeam && match.opponentTeam.length > 0 ? (
              match.opponentTeam.map((player, index) => {
                const playerName = player.userId
                  ? userNames[player.userId] || player.name
                  : player.name;
                return (
                  <div
                    key={index}
                    style={{
                      padding: "8px 0",
                      borderBottom: "1px solid #dee2e6",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      <strong>#{player.number}</strong> {playerName}
                      {player.isLibero && (
                        <span
                          style={{
                            color: "#28a745",
                            fontSize: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          (Libero)
                        </span>
                      )}
                      {player.isCustom && (
                        <span
                          style={{
                            color: "#6c757d",
                            fontSize: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          (Custom)
                        </span>
                      )}
                    </span>
                    <span style={{ fontSize: "12px", color: "#6c757d" }}>
                      {player.position}
                    </span>
                  </div>
                );
              })
            ) : (
              <div style={{ color: "#6c757d", fontStyle: "italic" }}>
                No players added
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Match Summary */}
      <div
        style={{
          backgroundColor: "white",
          padding: "clamp(15px, 4vw, 20px)",
          borderRadius: "8px",
          marginTop: "clamp(15px, 4vw, 20px)",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        }}
      >
        <h4
          style={{
            color: "#2c3e50",
            marginBottom: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(15px, 3vw, 18px)",
          }}
        >
          🏆 Match Summary
        </h4>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(12px, 2.5vw, 14px)",
          }}
        >
          <div>
            <strong>Winner:</strong>{" "}
            <span
              style={{
                color:
                  match.winner === "user"
                    ? "#27ae60"
                    : match.winner === "opponent"
                    ? "#e74c3c"
                    : "#6c757d",
                fontWeight: "bold",
              }}
            >
              {match.winner === "user"
                ? match.userTeamName || "Your Team"
                : match.winner === "opponent"
                ? match.opponentTeamName || "Opponent Team"
                : "In Progress"}
            </span>
          </div>
          <div>
            <strong>Match Type:</strong>{" "}
            {match.matchType === "best_of_3" ? "Best of 3" : "Best of 5"}
          </div>
          <div>
            <strong>Sets Played:</strong> {match.sets?.length || 0}
          </div>
          <div>
            <strong>Sets Score:</strong> {match.userSets} - {match.opponentSets}
          </div>
          <div>
            <strong>Total Players:</strong>{" "}
            {(match.userTeam?.length || 0) + (match.opponentTeam?.length || 0)}
          </div>
        </div>
      </div>
    </div>
  ));
};

export default VolleyballMatchDetails;
